import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
      "Droid Sans", "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body{
    min-height: 100vh;
    min-width: 100vw;
    overflow-x: hidden;
  }

  .App{
      background-color: ${(props) => props.theme.bgColor};
      color: ${(props) => props.theme.color};
  }
  
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
  }
  
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  #wrapper-all-web {
    position: relative;
  }
  /* container */
  
  .container {
    width: 100%;
    margin: 0 auto;
  }
  @media (min-width: 576px) {
    .container {
      max-width: 540px;
    }
  }
  @media (max-width: 587px) {
    .container {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
  
  @media (min-width: 768px) {
    .container {
      max-width: 720px;
    }
  }
  
  @media (min-width: 992px) {
    .container {
      max-width: 960px;
    }
  }
  
  @media (min-width: 1200px) {
    .container {
      max-width: 1140px;
    }
  }
  /*--------------Scroll Bar---------------------------------*/
  
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #dedede;
    // border-radius: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /*----------------------------------------------------*/
  .active-visible {
    opacity: 1 !important;
    visibility: visible !important;
  }
  a {
    cursor: pointer;
    text-decoration: none;
  }
  ul {
    list-style: none;
    margin-bottom: 0;
  }
  .text-center {
    text-align: center !important;
  }
  .item-center {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
  .d-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .justify-content-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
  .align-items-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
  .space-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .flex-column {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .img-fluid {
    max-width: 100%;
  }
  .grid-container {
    display: -ms-grid !important;
    display: grid !important;
  }
  .grid-2-col {
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
  }
  .grid-3-col {
    -ms-grid-columns: 1fr 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 992px) {
    .grid-3-col {
      -ms-grid-columns: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
      -ms-grid-rows: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }
    .grid-3-col > *:nth-child(1) {
      -ms-grid-row: 1;
      -ms-grid-column: 1;
    }
    .grid-3-col > *:nth-child(2) {
      -ms-grid-row: 1;
      -ms-grid-column: 2;
    }
    .grid-3-col > *:nth-child(3) {
      -ms-grid-row: 2;
      -ms-grid-column: 1;
    }
    .grid-3-col > *:nth-child(4) {
      -ms-grid-row: 2;
      -ms-grid-column: 2;
    }
  }
  @media (max-width: 576px) {
    .grid-3-col {
      -ms-grid-columns: auto;
      grid-template-columns: auto;
      -ms-grid-rows: auto auto auto;
      grid-template-rows: auto auto auto;
    }
    .grid-3-col > *:nth-child(1) {
      -ms-grid-row: 1;
      -ms-grid-column: 1;
    }
    .grid-3-col > *:nth-child(2) {
      -ms-grid-row: 2;
      -ms-grid-column: 1;
    }
    .grid-3-col > *:nth-child(3) {
      -ms-grid-row: 3;
      -ms-grid-column: 1;
    }
    .grid-3 {
      -ms-grid-column: unset !important;
      grid-column-start: unset !important;
      -ms-grid-column-span: NaN !important;
      grid-column-end: unset !important;
    }
  }
  @media (max-width: 768px) {
    .grid-2-col {
      -ms-grid-columns: 1fr;
      grid-template-columns: 1fr;
      -ms-grid-rows: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }
    #roadmap .grid-2-col {
      -ms-grid-rows: 1fr 350px;
      grid-template-rows: 1fr 350px;
    }
  }
  
  .grid-4-col {
    -ms-grid-columns: 1fr 1fr 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  
  /* @media (max-width: 768px){
  .grid-4-col{
      -ms-grid-columns: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
      -ms-grid-rows: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
  }
  .grid-4-col > *:nth-child(1){
      -ms-grid-row: 1;
      -ms-grid-column: 1;
  }
  .grid-4-col > *:nth-child(2){
      -ms-grid-row: 1;
      -ms-grid-column: 2;
  }
  .grid-4-col > *:nth-child(3){
      -ms-grid-row: 2;
      -ms-grid-column: 1;
  }
  .grid-4-col > *:nth-child(4){
      -ms-grid-row: 2;
      -ms-grid-column: 2;
  }
  } */
  .pos-relative {
    position: relative !important;
  }
  .d-none {
    display: none;
  }
  
`;
